import request from '@/utils/http'
import global_var from '@/api/global_var.js'    //引用文件

// const BASE_URL = "http://118.89.164.56:8080/";
// const BASE_URL = "http://localhost:8080/";

const BASE_URL = global_var.baseURL

//获取作品集
export const getArticleCollectionContentList = () => {
    return request.requestGet(BASE_URL+"portal/article/getArticleCollectionContentList")
};